import { API } from 'network/api';
import { VALIDATION_ERROR_CODES } from './constants';
export const validateEmail = (emailField) => {
  if (emailField == '' || emailField == null) return true;
  var reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
  if (reg.test(emailField) == false) {
    return false;
  }
  return true;
};

// Function to validate password strength
export const validatePassword = (password) => {
  if (password === '') {
    return true;
  }
  return password.length >= 8;
};

// Function to validate if a field is not empty
export const validateNotEmpty = (field) => {
  return field.trim() !== '';
};

export const isNotNullUndefined = (value) => {
  return value !== null && value !== undefined && value !== '';
};

export const validatePhoneNumber = (phone, countryCode, setValidating) => {
  setValidating(true);
  return API.put('/user/validate-phone-number', {
    phone,
    countryCode,
  })
    .then((response) => {
      const { isValid } = { ...response?.data };
      if (isValid) {
        return Promise.resolve();
      }
      if (response.data?.errorCode) {
        const key = response.data.errorCode;
        Promise.reject(VALIDATION_ERROR_CODES[key]);
        return;
      }
      Promise.reject('Phone Number is not valid.');
    })
    .catch((error) => {
      console.error('Error validating phone number:', error);
      return Promise.reject(new Error('Phone number validation failed!'));
    })
    .finally(() => {
      setValidating(false);
    });
};
